document.addEventListener('DOMContentLoaded', function() {
  // Select all radio inputs within the '.shopify_subscriptions_app_block_label' elements
  const subscriptionBlocks = document.querySelectorAll('.shopify_subscriptions_app_block_label input[type="radio"]');

  // Function to add active class based on the checked radio input
  function updateActiveClass() {
    // Remove 'active' class from all parent blocks
    subscriptionBlocks.forEach((el) => el.closest('.shopify_subscriptions_app_block_label').classList.remove('active'));

    // Add 'active' class to the parent of the checked input
    subscriptionBlocks.forEach((radio) => {
      if (radio.checked) {
        radio.closest('.shopify_subscriptions_app_block_label').classList.add('active');
      }
    });
  }

  // Add a change event listener to each radio input
  subscriptionBlocks.forEach((radio) => {
    radio.addEventListener('change', function() {
      updateActiveClass();
    });
  });

  // Initialize the active class on page load
  updateActiveClass(); // This will add 'active' to the default checked radio's parent
});
